import { render, staticRenderFns } from "./PaginaBilancioMinistero.vue?vue&type=template&id=7912bc5c"
import script from "./PaginaBilancioMinistero.vue?vue&type=script&lang=js"
export * from "./PaginaBilancioMinistero.vue?vue&type=script&lang=js"
import style0 from "./PaginaBilancioMinistero.vue?vue&type=style&index=0&id=7912bc5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports